module.exports = __webpack_public_path__ + "img/客户.33e395ee.png";